import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';

const LandingPage = () => {
  const [showLogin, setShowLogin] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { signIn, user } = UserAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await signIn(email, password);
      navigate('/admin');
    } catch (e) {
      setError(e.message);
      console.log(e.message);
    }
  };

  return (
    <div className="overflow-x-hidden bg-[#f5f0e8] text-[#1a3d1a]">

      {/* HERO */}
      <section className="relative flex min-h-screen flex-col items-center justify-center bg-[radial-gradient(ellipse_at_center_top,_#c8dfc8_0%,_#f5f0e8_60%)] px-5 py-16 text-center">

        <div className="mb-6 animate-bounce [animation-duration:5s]">
          <img
            src="/suitcase_Koffer_logo.png"
            alt="Koffer"
            className="w-[140px] drop-shadow-[6px_8px_0px_rgba(26,61,26,0.35)]"
          />
        </div>

        <h1
        className="mb-3 tracking-[2px] text-[#1a3d1a]"
        style={{
            fontFamily: "'Press Start 2P', monospace",
            fontSize: 'clamp(28px, 6vw, 52px)',
            textShadow: '4px 4px 0 #4CAF50',
        }}
        >
        Koffer
        </h1>

        <p className="mb-10 text-lg font-extrabold uppercase tracking-[3px] text-[#3a7d3a]">
          Drop Bags & Explore
        </p>

        <p className="mb-12 max-w-[520px] text-lg leading-8 text-[#1a3d1a]/80">
          Dejá tu equipaje en manos seguras y explorá la ciudad sin peso.
          Guardado de maletas simple, rápido y confiable en tres pasos.
        </p>

        <button
        onClick={() => {
            document
            .getElementById('como-funciona')
            ?.scrollIntoView({ behavior: 'smooth' });
        }}
        className="bg-[#1a3d1a] px-8 py-4 font-mono text-sm font-bold tracking-[1px] text-white shadow-[5px_5px_0px_#4CAF50] transition hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[2px_2px_0px_#4CAF50]"
        style={{
            fontFamily: "'Press Start 2P', monospace",
        }}
        >
        ▶ CÓMO FUNCIONA
        </button>

      </section>

      {/* HOW IT WORKS */}
      <section id="como-funciona" className="px-5 py-24">

        <div className="mb-16 text-center">
          <span className="mb-4 block font-mono text-[10px] uppercase tracking-[4px] text-[#4CAF50]">
            // PROCESO
          </span>

          <h2
            style={{
                fontFamily: "'Press Start 2P', monospace",
                fontSize: 'clamp(16px, 3vw, 26px)',
                color: '#1a3d1a',
                textShadow: '3px 3px 0 #9ad49a',
                lineHeight: '1.5',
            }}
          >
            3 PASOS SIMPLES
          </h2>
        </div>

        <div className="mx-auto grid max-w-[1100px] gap-8 md:grid-cols-3">

          {/* STEP 1 */}
          <div className="border-[3px] border-[#1a3d1a] bg-white p-8 shadow-[8px_8px_0px_#1a3d1a] transition hover:translate-x-1 hover:translate-y-1 hover:shadow-[4px_4px_0px_#1a3d1a]">

            <div className="mb-6 inline-block bg-[#1a3d1a] px-3 py-2 font-mono text-[11px] text-[#4CAF50]">
              PASO 01
            </div>

            <div className="mb-4 text-6xl">📲</div>

            <h3 className="mb-4 font-mono text-sm leading-7 text-[#1a3d1a]"
            style={{
                fontFamily: "'Press Start 2P', monospace",
            }}
            >
              ESCANEÁ EL QR <br /> & REGISTRATE
            </h3>

            <p className="text-[15px] leading-7 text-[#4a5a4a]">
              Apuntá la cámara de tu celular al código QR y completá tus datos en segundos.
            </p>

          </div>

          {/* STEP 2 */}
          <div className="border-[3px] border-[#1a3d1a] bg-white p-8 shadow-[8px_8px_0px_#1a3d1a] transition hover:translate-x-1 hover:translate-y-1 hover:shadow-[4px_4px_0px_#1a3d1a]">

            <div className="mb-6 inline-block bg-[#1a3d1a] px-3 py-2 font-mono text-[11px] text-[#4CAF50]">
              PASO 02
            </div>

            <div className="mb-4 text-6xl">🧳</div>

            <h3 className="mb-4 font-mono text-sm leading-7 text-[#1a3d1a]"
            style={{
                fontFamily: "'Press Start 2P', monospace",
            }}
            >
              DEJÁ TUS <br /> MALETAS
            </h3>

            <p className="text-[15px] leading-7 text-[#4a5a4a]">
              Entregá tu equipaje al staff y recibí tu código de retiro por email y WhatsApp.
            </p>

          </div>

          {/* STEP 3 */}
          <div className="border-[3px] border-[#1a3d1a] bg-white p-8 shadow-[8px_8px_0px_#1a3d1a] transition hover:translate-x-1 hover:translate-y-1 hover:shadow-[4px_4px_0px_#1a3d1a]">

            <div className="mb-6 inline-block bg-[#1a3d1a] px-3 py-2 font-mono text-[11px] text-[#4CAF50]">
              PASO 03
            </div>

            <div className="mb-4 text-6xl">🔑</div>

            <h3 className="mb-4 font-mono text-sm leading-7 text-[#1a3d1a]"
            style={{
                fontFamily: "'Press Start 2P', monospace",
            }}
            >
              RETIRÁ TUS <br /> MALETAS
            </h3>

            <p className="text-[15px] leading-7 text-[#4a5a4a]">
              Volvé cuando quieras y retiralas mostrando tu código único.
            </p>

          </div>

        </div>
      </section>

{/* REGISTER */}
<section className="relative overflow-hidden bg-[#1a3d1a] px-5 py-28 text-center">

  {/* pixel background */}
  <div className="absolute inset-0 opacity-10">
    <div className="h-full w-full bg-[linear-gradient(to_right,#4CAF50_1px,transparent_1px),linear-gradient(to_bottom,#4CAF50_1px,transparent_1px)] bg-[size:32px_32px]" />
  </div>

  <div className="relative z-10">

    <span className="mb-4 block font-mono text-[10px] uppercase tracking-[4px] text-[#9ad49a]">
      // CHECK-IN DIGITAL
    </span>

    <h2 className="font-mono text-3xl font-black leading-[1.5] text-[#4CAF50] md:text-5xl"
        style={{
            fontFamily: "'Press Start 2P', monospace",
        }}
    >
      ESCANEÁ EL QR <br />
      EN EL LOCAL
    </h2>

    <p className="mx-auto mt-8 max-w-[760px] text-lg leading-9 text-[#d8ead8]">
      Cuando llegues al punto de guardado de equipaje,
      buscá el código QR de Koffer y escanealo con tu celular.
      Vas a poder completar el formulario en segundos
      y dejar tus valijas de forma rápida y segura.
    </p>



    {/* button */}
<button
  className="mt-20 bg-[#f5f0e8] px-8 py-4 text-sm font-black tracking-[2px] text-[#1a3d1a] shadow-[6px_6px_0px_#4CAF50] transition hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[2px_2px_0px_#4CAF50]"
  style={{
    fontFamily: "'Press Start 2P', monospace",
  }}
>
  ▶ VER UBICACIONES
</button>

  </div>

</section>

      {/* WHY */}
      <section className="bg-[#e8e0d0] px-5 py-24">

        <div className="mb-16 text-center">
          <span className="mb-4 block font-mono text-[10px] uppercase tracking-[4px] text-[#4CAF50]">
            // POR QUÉ ELEGIRNOS
          </span>

          <h2 className="font-mono text-3xl font-black leading-[1.5] text-[#1a3d1a] md:text-5xl"
            style={{
                fontFamily: "'Press Start 2P', monospace",
            }}
          >
            SEGURO, RÁPIDO <br /> & CONFIABLE
          </h2>
        </div>

        <div className="mx-auto grid max-w-[900px] gap-6 md:grid-cols-4">

          {[
            ['🔒', '100% SEGURO'],
            ['⚡', 'PROCESO EXPRESS'],
            ['📍', 'UBICACIÓN CENTRAL'],
            ['💬', 'SOPORTE REAL'],
          ].map((item, index) => (
            <div
              key={index}
              className="border-[3px] border-[#1a3d1a] bg-white p-7 text-center shadow-[5px_5px_0px_#3a7d3a]"
            >
              <div className="mb-4 text-4xl">{item[0]}</div>

              <p className="mb-3 font-mono text-[9px] leading-6 text-[#1a3d1a]">
                {item[1]}
              </p>

              <p className="text-sm leading-6 text-[#5a6a5a]">
                Equipaje protegido y atención rápida.
              </p>
            </div>
          ))}

        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-[#1a3d1a] px-5 py-16 text-center text-[#a8d8a8]">

        <div className="mb-3 font-mono text-2xl text-[#4CAF50]"
        style={{
            fontFamily: "'Press Start 2P', monospace",
        }}
        >
          Koffer
        </div>

        <div className="mb-10 text-sm uppercase tracking-[3px] opacity-70">
          Drop Bags & Explore
        </div>

        <div className="mb-10 flex flex-wrap justify-center gap-8 text-sm font-semibold">
          <button
            onClick={() => {
            document
            .getElementById('como-funciona')
            ?.scrollIntoView({ behavior: 'smooth' });
        }}
          >Cómo funciona</button>
          <a href="/terminos">Términos</a>
        </div>

        <button
        onClick={() => {
            if (user) {
            navigate('/admin');
            } else {
            setShowLogin(true);
            }
        }}
        className="mb-10 border-[3px] border-[#a8d8a8] bg-[#4CAF50] px-6 py-3 font-mono text-[9px] text-[#1a3d1a] shadow-[4px_4px_0px_rgba(0,0,0,0.3)] transition hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0px_rgba(0,0,0,0.3)]"
        style={{
            fontFamily: "'Press Start 2P', monospace",
        }}
        >
          INGRESAR COMO ADMINISTRADOR
        </button>

        <div className="text-xs opacity-50">
          © 2026 Koffer — Todos los derechos reservados
        </div>

      {/* MODAL */}
      {showLogin && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 px-4">
          <div className="relative w-full max-w-[520px] border-[4px] border-[#4CAF50] bg-[#f5f0e8] p-8 shadow-[10px_10px_0px_#4CAF50]">
            {/* CLOSE */}
            <button
              onClick={() => setShowLogin(false)}
              className="absolute right-4 top-4 text-2xl font-black text-[#1a3d1a]"
            >
              ✕
            </button>
            <h2
              className="mb-8 text-center text-[20px] leading-[2] text-[#1a3d1a]"
              style={{
                fontFamily: "'Press Start 2P', monospace",
              }}
            >
              ADMIN LOGIN
            </h2>
            {error && (
              <div className="mb-6 border-[3px] border-red-500 bg-red-100 p-4 text-sm font-bold text-red-700">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              {/* EMAIL */}
              <div className="mb-5">
                <label
                  className="mb-3 block text-[10px] text-[#1a3d1a]"
                  style={{
                    fontFamily: "'Press Start 2P', monospace",
                  }}
                >
                  EMAIL
                </label>
                <input
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full border-[3px] border-[#1a3d1a] bg-white px-4 py-4 outline-none focus:border-[#4CAF50]"
                />
              </div>
              {/* PASSWORD */}
              <div className="mb-8">
                <label
                  className="mb-3 block text-[10px] text-[#1a3d1a]"
                  style={{
                    fontFamily: "'Press Start 2P', monospace",
                  }}
                >
                  PASSWORD
                </label>
                <input
                  type="password"
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full border-[3px] border-[#1a3d1a] bg-white px-4 py-4 outline-none focus:border-[#4CAF50]"
                />
              </div>
              {/* SUBMIT */}
              <button
                type="submit"
                className="w-full bg-[#1a3d1a] px-6 py-5 text-white shadow-[6px_6px_0px_#4CAF50] transition hover:translate-x-[3px] hover:translate-y-[3px] hover:shadow-[2px_2px_0px_#4CAF50]"
                style={{
                  fontFamily: "'Press Start 2P', monospace",
                  fontSize: '10px',
                }}
              >
                ▶ INGRESAR
              </button>
            </form>
          </div>
        </div>
      )}

      </footer>

    </div>
  );
};

export default LandingPage;